exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posicion[data-v-8e3e8a96]{position:absolute;z-index:1;width:18vw}#tarjetaPopUp[data-v-8e3e8a96]{width:95%;height:auto;padding:2.4vh;border-radius:8px}#contenedorFormulario[data-v-8e3e8a96]{display:flex;justify-content:space-between;width:100%}#NombreFormulario[data-v-8e3e8a96]{margin:0;text-align:left;font-size:2.1vh;color:#ccc;width:90%}#imagenVerificacion[data-v-8e3e8a96]{width:8%;height:8%;margin:.6vh;filter:invert(18%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e3e8a96","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/PopUp/popUp.scss
// module id = 946
// module chunks = 0